import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * EMISSÃO DO DIÁRIO — migração de `EmitirDiarioEletronico.aspx` e `EmitirCadernoTurma.aspx`.
 *
 * DUAS rotas e DUAS permissões, ainda que a folha impressa seja a mesma. O recorte de quem usa é
 * diferente: o professor emite o diário DELE (uma turma × disciplina), e a supervisão emite a
 * turma inteira. Duas permissões é o que permite a rede liberar uma sem a outra — o professor não
 * precisa poder tirar o caderno da turma toda, e a supervisão precisa poder tirá-lo sem ter
 * alocação nenhuma.
 *
 * As permissões são as NOVAS (300300502 e 300300503) e nunca a do item legado (300300500) —
 * ver CLAUDE.md, "Permissão de tela nova": enquanto as duas versões convivem, a rede precisa
 * ligar uma sem ligar a outra. Os `INSERT` na `Seg_Menu` ficam em
 * `saeweb-database-sql/consultebase/scripts/2026-09-10-Permissoes-EmissaoDiario.sql`.
 */
export default [
  {
    description: 'Diário de Classe',
    path: '/academico/diario/emissao',
    name: 'emissao_diario_classe',
    component: () => import('@/views/academico/diario/emissao/Diario.vue'),
    meta: {
      permissions: [eTipoPermissao.EMISSAODEDIARIOELETRONICONOVO_MENU_300300502],
    },
    goesToMenu: true,
  },
  {
    description: 'Caderno da Turma',
    path: '/academico/diario/caderno',
    name: 'emissao_caderno_turma',
    component: () => import('@/views/academico/diario/emissao/Caderno.vue'),
    meta: {
      permissions: [eTipoPermissao.EMISSAODECADERNODATURMANOVO_MENU_300300503],
    },
    goesToMenu: true,
  },
];
